import axios from '../axios';

export function subscribeToTrending(type) {
  return axios.put('/api/v1/profiles/me/notification_settings/trending/subscribe.json', {
    authenticity_token: Livewire.formAuthenticityToken,
    type,
  });
}

export function unsubscribeFromTrending(type) {
  return axios.put('/api/v1/profiles/me/notification_settings/trending/unsubscribe.json', {
    authenticity_token: Livewire.formAuthenticityToken,
    type,
  });
}

export function updateNotifyOnFollow(options) {
  return axios.post('/api/v1/profiles/me/notification_settings/notify_on_follow.json', {
    authenticity_token: Livewire.formAuthenticityToken,
    notify_on_follow_options: options,
  });
}

export function updateNotifyOnLike(options) {
  return axios.post('/api/v1/profiles/me/notification_settings/notify_on_like.json', {
    authenticity_token: Livewire.formAuthenticityToken,
    notify_on_like_options: options,
  });
}

export function updateNotifyOnComment(options) {
  return axios.post('/api/v1/profiles/me/notification_settings/notify_on_comment.json', {
    authenticity_token: Livewire.formAuthenticityToken,
    notify_on_comment_options: options,
  });
}

export function updateNotifyOnMention(options) {
  return axios.post('/api/v1/profiles/me/notification_settings/notify_on_mention.json', {
    authenticity_token: Livewire.formAuthenticityToken,
    notify_on_mention_options: options,
  });
}
